import { WitaConnector } from '@/services/repository/connector'
import { FormDataHandler } from '@/utils/helpers/FormDataHandler'
import { querySerializer } from '@/utils/helpers/URLs'

import { Repo } from './Vista.d'

const ROOT_URL = '/entity/vistas'

export const VistaRepository = {
  FindByEquipmentId: async (params: Repo.Vista.FindByEquipmentId.Params) => {
    const url = ROOT_URL + `?${querySerializer(params)}`
    return await WitaConnector.get<Repo.Vista.FindByEquipmentId.Response>(url)
  },

  FindById: async ({ vistaId }: Repo.Vista.FindById.Params) => {
    const url = ROOT_URL + `/${vistaId}`
    return await WitaConnector.get<Repo.Vista.FindById.Response>(url)
  },

  Create: async (params: Repo.Vista.Create.Params) => {
    const formData = FormDataHandler(params)
    const url = ROOT_URL
    return await WitaConnector.post<Repo.Vista.Create.Response>(url, formData)
  },

  Edit: async ({ id, ...params }: Repo.Vista.Edit.Params) => {
    const formData = FormDataHandler(params)
    const url = ROOT_URL + `/${id}`
    return await WitaConnector.put<Repo.Vista.Edit.Response>(url, formData)
  },

  Delete: async ({ id }: Repo.Vista.Delete.Params) => {
    const url = ROOT_URL + `/${id}`
    return await WitaConnector.delete<Repo.Vista.Delete.Response>(url)
  },
}
